import { useEffect } from 'react';

export function useTemplate(name: 'home' | 'dashboard') {
  useEffect(() => {
    const html = document.documentElement;

    html.setAttribute('data-template', name);

    return () => {
      html.removeAttribute('data-template');
    };
  }, [name]);
}
